<script>
export default {
	props: {
		items: Array,
		link: [String, Object],
	},
	methods: {
		subChild(child, n = 4) {
			return child.children?.slice(0, n) || []
		},
		hasManySubChildren(child, n = 4) {
			return child.children?.length > n
		},
	},
}
</script>

<template>
	<v-row justify="start" class="pl-4 pt-0" :class="$bem('submenu')">
		<v-col cols="9">
			<div id="menu" class="pt-0">
				<div
					v-for="ordered of items"
					:key="ordered.posId"
					class="category mb-4 pr-2"
					:class="$bem('__children')"
				>
					<div v-if="ordered.type == 'link'">
						<SafeLink
							v-if="ordered.selectType == 'category'"
							class="font-1 font-weight-bold pb-1 link"
							:to="
								$shop.getShopRoute({
									categories: ordered.category.familyUrlNames,
								})
							"
						>
							<span class="ellipsis-text">
								{{ ordered.category.name }}
							</span>
						</SafeLink>
						<SafeLink
							v-if="ordered.selectType == 'brand'"
							class="font-1 font-weight-bold pb-1 link"
							:to="$shop.getShopRoute({ brand: ordered.brand.urlName })"
						>
							<span class="ellipsis-text">{{ ordered.brand.name }}</span>
						</SafeLink>
						<SafeLink v-else class="pb-1" :to="ordered.link">
							<HtmlOrSlot :text="ordered.name">
								<span class="font-1 font-weight-bold link ellipsis-text">
									{{ ordered.name }}
								</span>
							</HtmlOrSlot>
						</SafeLink>
						<div :class="$bem('__subcategories')">
							<div v-for="(child, n) in ordered.children" :key="n">
								<SafeLink
									v-if="child.selectType == 'category'"
									:to="
										$shop.getShopRoute({
											categories: child.category.familyUrlNames,
										})
									"
									class="font-weight-bold pb-1 link"
								>
									{{ child.category.name }}
								</SafeLink>
								<SafeLink
									v-if="child.selectType == 'brand'"
									:to="
										$shop.getShopRoute({
											brand: child.brand.urlName,
										})
									"
									class="font-weight-bold pb-1 link"
								>
									{{ child.brand.name }}
								</SafeLink>
								<SafeLink v-else :to="child.link" class="pb-1">
									<HtmlOrSlot :text="child.name">
										<span class="font-weight-bold link">{{ child.name }}</span>
									</HtmlOrSlot>
								</SafeLink>
							</div>
						</div>
					</div>

					<div v-else>
						<SafeLink
							class="pb-1"
							:to="
								$shop.getShopRoute({
									categories: ordered.familyUrlNames,
								})
							"
						>
							<HtmlOrSlot :text="ordered.name">
								<span class="font-1 font-weight-bold link">{{ ordered.name }}</span>
							</HtmlOrSlot>
						</SafeLink>
						<div :class="$bem('__subcategories')">
							<div v-for="(subChild, i) in subChild(ordered)" :key="i">
								<SafeLink
									:to="$shop.getShopRoute({ categories: subChild.familyUrlNames })"
									class="pb-1"
								>
									<HtmlOrSlot :text="subChild.name">
										<span class="font-weight-bold link">{{ subChild.name }}</span>
									</HtmlOrSlot>
								</SafeLink>
							</div>
						</div>
						<SafeLink
							v-if="hasManySubChildren(ordered)"
							class="font-1 link"
							:to="$shop.getShopRoute({ categories: ordered.familyUrlNames })"
						>
							<span>Ver más</span>
						</SafeLink>
					</div>
				</div>
				<v-col>
					<SafeLink :to="link">
						<div :class="$bem('__image')"></div>
					</SafeLink>
				</v-col>
			</div>
		</v-col>
		<v-col>
			<SafeLink :to="link">
				<div :class="$bem('__image')"></div>
			</SafeLink>
		</v-col>
	</v-row>
</template>

<style scoped lang="scss">
#menu {
	column-count: 3;
	column-gap: 10px;
}

.submenu {
	&__children {
		break-inside: avoid-column;
	}

	&__subcategories {
		font-size: 13px;
	}

	&__children,
	&__subcategories {
		& a {
			opacity: 0.65;
			&:hover {
				opacity: 1;
			}
		}
	}

	&__image {
		position: absolute;
		width: 230px;
		height: 100%;
		background-color: transparent;
		right: 0;
		bottom: 0;
	}
}
</style>

